import { render } from "./StatsWidgetDataRender.vue?vue&type=template&id=4cc97e73"
import script from "./StatsWidgetDataRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetDataRender.vue?vue&type=script&lang=ts"

import "./StatsWidgetDataRender.vue?vue&type=style&index=0&id=4cc97e73&lang=scss"
script.render = render

export default script